import { useEffect, useRef, useState } from "react";

// Lightweight fade/slide-in (replaces framer-motion on the homepage to keep the main bundle small)
const Reveal = ({ as: Tag = "div", y = 20, delay = 0, duration = 0.6, onMount = false, className, style, children, ...rest }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (onMount || !el || typeof IntersectionObserver === "undefined") {
      const id = requestAnimationFrame(() => setShown(true));
      return () => cancelAnimationFrame(id);
    }
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setShown(true); io.disconnect(); }
    }, { threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [onMount]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        ...style,
        opacity: shown ? 1 : 0,
        transform: shown ? "none" : `translateY(${y}px)`,
        transition: `opacity ${duration}s ease-out ${delay}s, transform ${duration}s ease-out ${delay}s`,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
